 <template>
  <div
    class="berita-page"
    :style="beritaPageStyle">
    <v-layout wrap>
      <v-flex>
        <section class="berita-section">
          <div>
            <!-- <v-card
              v-if="process.load"
              flat
              height="250"
              width="100vw"
              color="#00000040">
              <v-skeleton-loader
                :loading="process.load"
                transition="scale-transition"
                :tile="false"
                class="ma-auto load_card_x_large"
                type="image"
                style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
              </v-skeleton-loader>
            </v-card> -->
            <div v-if="!process.load">
                <!-- <v-card
                  flat
                  cover
                  v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' "
                  class="background-default">
                  <v-img :src="require('@/assets/image/Candi-Prambanan.jpg')" width="100%" height="250" style="opacity: 0.75;" :gradient="`to right, ${set_color_rgb_up}, #000000a6`" class="img_center align-center">

                    <div class="d-flex align-center justify-center font-weight-black">
                      <div class="text-center">
                        <div
                          class="text-h4 white--text justify-center mb-2 pt-6"
                          style="font-weight: 500;">
                          {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span>
                        </div>

                        <div
                          class="body-1 white--text text-center mb-4"
                          style="opacity: 50%; font-weight: 500;">
                          Mengenal {{ category[selected.category].category_title }} <span v-if="selected.category === 0">Berita</span> di kabupaten Klaten.
                        </div>
                      </div>
                    </div>

                  </v-img>
                </v-card> -->
            </div>
          </div>
          <v-container :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'px-0' : ''">
            <!-- Hero: judul + search (desktop) -->
            <v-row v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'" class="berita-hero-row">
              <v-col cols="12" class="berita-hero-col">
                <div class="berita-hero" :style="{ '--berita-hero-bg': set_color, '--berita-hero-dark': set_color_dark }">
                  <div class="berita-hero-inner">
                    <div class="berita-hero-text">
                      <h1 class="berita-hero-title">Berita</h1>
                      <p class="berita-hero-subtitle">Informasi terbaru seputar Kabupaten Klaten</p>
                    </div>
                    <div class="berita-hero-search">
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div>
              <v-row>
                <!-- <v-col cols="12" md="3">
                  <v-skeleton-loader
                    :loading="process.load"
                    v-if="process.load"
                    transition="scale-transition"
                    :tile="false"
                    class="ma-auto load_card_x_large"
                    type="image"
                    style="width: 100% !important; height: 800px !important; min-height: 800px !important;">
                  </v-skeleton-loader>
                  <v-card
                    class="mx-auto"
                    v-if="!process.load"
                    style="border-radius: 15px;"
                    min-height="100%"
                    :class="'elevation-0'"
                    >
                    <v-card-title>
                      <div class="font-weight-medium" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'  ? 'text-h6' : 'body-1 text-center w-100'">
                        <span>Kategori</span> Berita
                      </div>
                    </v-card-title>
                    <v-list flat v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                      <v-list-item-group
                        v-model="selected.category"
                        mandatory
                        :color="set_color"
                      >
                        <v-list-item
                          v-for="(item, i) in category"
                          :key="i"
                          @click="selected.category = i; changeQuery(item.category_name); fetch(item.id)"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-img
                              width="40px"
                              alt="Kabupaten Klaten"
                              :src="item.category_icon_url === '' ? require('@/assets/image/no-photo.png') : item.category_icon_url">
                            </v-img>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>{{ item.category_title }}</v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action class="ml-0 my-0">
                            <v-chip
                              class="ma-2"
                              small
                              style="min-width: 40px; text-align: center; justify-content: center;"
                              text-color="white"
                              :color="`${set_color}`"
                            >
                              {{ item.count }}
                            </v-chip>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                    <v-slide-group
                      v-model="selected.category"
                      class="px-0 pb-5"
                      mandatory
                      show-arrows
                      v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'"
                    >
                      <v-slide-item
                        v-for="n in category"
                        :key="n"
                        v-slot="{ active }"
                      >
                      <v-btn
                          class="mx-2 text-capitalize"
                          :input-value="active"
                          :color="active ? `${set_color}` : ``"
                          :active-class="`white--text`"
                          depressed
                          rounded
                          @click="selected.category = i; changeQuery(n.category_name); fetch(n.id)"
                        >
                          {{ n.category_title }}
                        </v-btn>
                      </v-slide-item>
                    </v-slide-group>
                  </v-card>
                </v-col> -->
                <v-col cols="12" md="9" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pt-0' : ''">
                  <!-- Mobile: judul + kategori + search -->
                  <div v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'" class="berita-mobile-header mb-4">
                    <h1 class="berita-mobile-title">Berita</h1>
                    <div class="berita-mobile-actions">
                      <v-autocomplete
                      v-model="filter.category"
                      :items="category"
                      item-text="category_title"
                      item-value="id"
                      hide-no-data
                      hide-details
                      dense
                      solo
                      single-line
                      placeholder="Pilih Kategori"
                      :color="set_color"
                      @change="changeQuery(category.find(item => item.id === filter.category).category_name); fetch(filter.category)"
                      class="berita-mobile-select"
                      append-icon="mdi-chevron-down">
                    </v-autocomplete>
                      <!-- <v-text-field
                        v-model="search"
                        placeholder="Cari berita..."
                        hide-details
                        dense
                        solo
                        flat
                        clearable
                        class="berita-mobile-search mt-2"
                        :color="set_color"
                        append-icon="mdi-magnify"
                        @click:append="fetch()"
                        @keyup.enter.native="fetch()"
                        @click:clear="search = ''; fetch();">
                      </v-text-field> -->
                    </div>
                  </div>
                  <v-row>
                    <v-col
                      v-for="(item, index) in process.load || process.list ? 8 : list"
                      :key="index"
                      :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 6 : 12"
                      md="4">
                      <v-skeleton-loader
                        :loading="process.load || process.list"
                        transition="scale-transition"
                        :tile="false"
                        class="ma-auto"
                        type="card">
                        <div>
                          <div v-if="!process.list && !process.load && list.length > 0"
                            class="berita-card-wrap">
                            <v-card
                              :to="`/berita/${item.slug}?q=${item.id}`"
                              @mouseover="voiceHover(item.title)"
                              class="berita-card"
                              width="100%">
                              <div class="berita-card-image-wrap">
                                <img
                                  :style="`height: ${$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 130 : 200}px;`"
                                  alt="Pemerintah Kabupaten Klaten"
                                  :src="item.image_url_cover === '' ? item.image_url === '' ? require('@/assets/image/no-photo.png') : item.image_url : item.image_url_cover"
                                  class="berita-card-image"
                                  @contextmenu.stop>
                              </div>

                              <div class="pa-3 berita-card-body">
                                <div class="berita-card-title" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-2 one-line' : 'fs-12 two-line'">
                                  {{ item.title }}
                                </div>

                                <div class="d-flex align-center mt-1 berita-card-meta">
                                  <v-icon small class="berita-card-meta-icon">mdi-account-circle-outline</v-icon>
                                  <span class="fs-11 one-line ml-1">Admin</span>
                                </div>

                                <div class="fs-11 font-weight-light three-line my-2 berita-card-excerpt">
                                  <span v-html="item.content.replace(/(<([^>]+)>)/ig, '')"></span>
                                </div>

                                <v-divider class="berita-card-divider my-2" />

                                <div class="fs-11 d-flex align-center berita-card-date">
                                  <v-icon x-small class="mr-1" style="opacity: 0.8;">mdi-calendar-outline</v-icon>
                                  {{ item.publish_datetime | date }}
                                </div>
                              </div>
                            </v-card>
                          </div>
                        </div>
                      </v-skeleton-loader>
                    </v-col>
                  </v-row>
                  <div v-if="!process.load && pagination.total_data > 0"
                    class="berita-pagination mt-4 mb-2">
                    <div class="berita-pagination-inner">
                      <div class="body-2 berita-pagination-info">
                        Total seluruh data: {{ (pagination.total_data || 0).toLocaleString('id-ID') }}
                      </div>
                      <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="$vuetify.breakpoint.smAndDown ? 5 : 7"
                        :color="set_color"
                        circle
                        prev-icon="mdi-chevron-left"
                        next-icon="mdi-chevron-right"
                        class="berita-pagination-control"
                        @input="onPageChange"
                      />
                    </div>
                  </div>

                  <Empty v-if="!process.load && pagination.total_page < 1"
                    class="py-12"
                    margin="my-16"
                    size="125"
                    message="Berita" />

                </v-col>
                <v-col cols="12" md="3" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                  <v-card flat class="berita-sidebar-card mb-6 mt-0">
                    <v-card-text class="berita-sidebar-content">
                      <div class="berita-sidebar-title" :style="{ color: set_color }">
                        <v-icon small class="mr-1">mdi-folder-outline</v-icon>
                        Kategori
                      </div>
                      <v-divider class="berita-sidebar-divider mb-0 mt-2"></v-divider>
                      <div v-for="(item, index) in process.load ? 8 : category" :key="index">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="list-item-three-line">
                          <div>
                            <div v-if="!process.load && category.length > 0" @mouseover="voiceHover(item.category_title)">
                              <v-list one-line class="py-0">
                                <v-list-item class="berita-category-item px-0" :class="{ 'berita-category-item--active': selected.category === index }" @click="selected.category = index; changeQuery(item.category_name); fetch(item.id)">
                                    <v-list-item-content class="py-2" :style="selected.category === index ? { color: set_color } : {}">
                                      <v-list-item-title class="berita-category-label">{{ item.category_title }}</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="my-0" v-if="selected.category === index">
                                      <v-icon x-small :color="set_color">mdi-chevron-right</v-icon>
                                    </v-list-item-action>

                                    <!-- <v-list-item-action class="my-0">
                                      <v-chip
                                        class="ma-2"
                                        small
                                        style="min-width: 40px; text-align: center; justify-content: center;"
                                        text-color="white"
                                        :color="`${set_color}`"
                                      >
                                        {{ item.count }}
                                      </v-chip>
                                    </v-list-item-action> -->
                                </v-list-item>

                              </v-list>
                              <v-divider
                                v-if="index < category.length - 1"
                              ></v-divider>
                            </div>
                          </div>
                        </v-skeleton-loader>
                      </div>
                    </v-card-text>
                  </v-card>

                  <Sidebar />
                </v-col>
              </v-row>
            </div>


          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        search: '',
        category: [
          {
            icon: 'mdi-newspaper',
            text: 'Berita',
            link: '/berita?category=utama'
          },
          {
            icon: 'mdi-newspaper-variant',
            text: 'Berita OPD',
            link: '/berita?category=opd'
          },
          {
            icon: 'mdi-newspaper-variant-outline',
            text: 'Berita Wilayah',
            link: '/berita?category=wilayah'
          },
        ],
        selected: {
          category: 0
        },
        filter: {
          category: ''
        },
        total_category: 0,
        list: [],
        pagination: {},
        currentPage: 1,
        pageSize: 12,
        process: {
          load: false,
          list: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/berita',
          title: 'Berita',
          description: 'Berita Kabupaten Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    // components: {
    //   Utama: () => import(/* webpackPrefetch: true */ '@/components/berita/utama.vue'),
    //   OPD: () => import(/* webpackPrefetch: true */ '@/components/berita/opd.vue'),
    //   Wilayah: () => import(/* webpackPrefetch: true */ '@/components/berita/wilayah.vue'),
    // },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
      Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
    },
    watch: {
      '$route.query.category': function(val) {
        this.changeLink(val)
      },
      '$route.query.search': function(val) {
        this.changeLink()
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_dark () {
        const hex = (this.$store.state.header.config.color || '#B71C1C').replace(/^#/, '')
        const r = Math.max(0, parseInt(hex.slice(0, 2), 16) * 0.65)
        const g = Math.max(0, parseInt(hex.slice(2, 4), 16) * 0.65)
        const b = Math.max(0, parseInt(hex.slice(4, 6), 16) * 0.65)
        return '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('')
      },
      beritaPalette () {
        const primary = this.set_color || '#B71C1C'
        return {
          '--berita-bg': '#FAF7F5',
          '--berita-surface': '#FFFFFF',
          '--berita-text': '#2D2D2D',
          '--berita-text-muted': '#6B6B6B',
          '--berita-border': '#E8E4E0',
          '--berita-primary': primary,
          '--berita-primary-soft': primary + '14',
          '--berita-accent': '#B8860B',
          '--berita-shadow': '0 2px 12px rgba(45, 45, 45, 0.06)',
          '--berita-shadow-hover': '0 8px 24px rgba(45, 45, 45, 0.1)'
        }
      },
      beritaPageStyle () {
        const isDesktop = this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm'
        const padding = isDesktop
          ? { paddingTop: '128px', paddingBottom: '280px' }
          : { paddingTop: '64px', paddingBottom: '650px' }
        return Object.assign({}, this.beritaPalette, padding)
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      totalPages () {
        const total = this.pagination.total_page ?? Math.ceil((this.pagination.total_data || 0) / this.pageSize)
        return Math.max(1, total)
      }
    },
    mounted () {
      this.fetchCategory()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetchCategory (id, type) {
        this.process.load = type === undefined ? true : false

        let params = {
          limit: 1000000,
          par_id: '1'
        }

        await this.$axios.$get(`${process.env.API}sites/article/category`, { params })
        .then(response => {
          let res = response

          if (res.status === 200) {
            this.category = [
              {
                category_title: "Semua Kategori",
                category_icon_url: require('@/assets/icon/app.png'),
                id: '',
                category_name: "semua-kategori",
                count: 0
              }
            ]
            let category = []
            category = res.results.data.map(item => {
                const container = {};

                container.category_title = item.title;
                container.category_icon_url = item.icon_url;
                container.id = item.id;
                container.category_name = item.slug;
                container.count = item.count

                // this.category = container;
                return container
              })


            for (let i in category) {
              this.category.push(
                {
                  category_title: category[i].category_title,
                  category_icon_url: category[i].category_icon_url,
                  id: category[i].id,
                  category_name: category[i].category_name,
                  count: category[i].count
                }
              )

            }

            for (let i in this.category) {
              this.total_category += parseInt(this.category[i].count)

            }

            this.process.load = false
            this.category[0].count = this.total_category
            this.changeLink()
          }
        })
      },
      onPageChange () {
        this.fetch()
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      async fetch () {
        this.process.list = true

        let params = this.filter.category === '' ? {
          'title[lse]': this.$route.query.search === undefined ? '' : this.$route.query.search,
          limit: this.pageSize,
          page: this.currentPage,
          'category_id[nin]': '2,15,16',
          'category_par_id': '1',
          sort: '-publish_datetime',
        } : {
          'title[lse]': this.$route.query.search === undefined ? '' : this.$route.query.search,
          limit: this.pageSize,
          page: this.currentPage,
          sort: '-publish_datetime',
          category_id: this.filter.category
        }

        await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
        .then(response => {
          let res = response


          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination

          }
          this.process.list = false
          this.process.load = false
        })
      },
      changeLink() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        let status = false
        let id = 0
        this.selected.category = 0
        this.filter.category = ''
        this.currentPage = 1


        if (this.$route.query.category !== undefined) {
          for(let i = 0; i < this.category.length; i++){
            if (this.category[i].category_name === this.$route.query.category) {
              this.filter.category = this.category[i].id
              this.selected.category = i
              status = true
            } else {
              // status = false
            }
          }
          // if (query === 'wisata') {
          //     this.selected = {
          //       category: 0,
          //     }
          // } else if (query === 'kuliner') {
          //   this.selected = {
          //     category: 1
          //   }
          // }
          // this.fetch(id)
        }
        // console.log(status)
        if (status === false) {
          this.$router.push(`/berita?category=${this.category[0].category_name}`)
        }

        console.log(id)

        this.fetch()
      },
      changeQuery(name) {
        if(name === '') {
          if (this.$route.query.search !== undefined) {
            this.$router.replace({'path': `/berita`, 'query': {'search': this.$route.query.search}})
          } else {
            this.$router.replace({'path': `/berita`})
          }
        } else {
          if (this.$route.query.search === undefined) {
            this.$router.replace({'path': `/berita`, 'query': {'category': name}})
          } else {
            this.$router.replace({'path': `/berita`, 'query': {'category': name, 'search': this.$route.query.search}})
          }
        }
      },
      toDetail(item) {
        this.$router.push(`/berita/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      },
    }
  }
</script>

<style scoped>
/* ---- Page ---- */
.berita-page {
  background-color: var(--berita-bg);
  min-height: 100vh;
  box-sizing: border-box;
}

.berita-section {
  min-height: 0;
}

/* ---- Hero (desktop) ---- */
.berita-hero-row {
  margin-bottom: 2rem;
}

.berita-hero-col {
  padding-top: 0;
  padding-bottom: 0;
}

.berita-hero {
  background: linear-gradient(135deg, var(--berita-hero-bg) 0%, var(--berita-hero-dark) 100%);
  border-radius: 16px;
  padding: 1.75rem 2rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
}

.berita-hero-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.berita-hero-text {
  flex: 0 0 auto;
}

.berita-hero-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 0.25rem 0;
  letter-spacing: -0.02em;
}

.berita-hero-subtitle {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.88);
  margin: 0;
}

.berita-hero-search {
  display: flex;
  align-items: stretch;
  gap: 0;
  flex: 1 1 320px;
  max-width: 420px;
}

.berita-hero-search-field {
  border-radius: 10px 0 0 10px !important;
  flex: 1;
}

.berita-hero-search-field >>> .v-input__slot {
  padding-left: 1rem !important;
}

.berita-hero-search-btn {
  border-radius: 0 10px 10px 0 !important;
  min-width: 88px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.02em;
}

/* ---- Mobile header ---- */
.berita-mobile-header {
  background: var(--berita-surface);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: var(--berita-shadow);
  border: 1px solid var(--berita-border);
}

.berita-mobile-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--berita-text);
  margin: 0 0 0.75rem 0;
}

.berita-mobile-actions {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.berita-mobile-select >>> .v-input__slot,
.berita-mobile-search >>> .v-input__slot {
  border-radius: 10px;
  border: 1px solid var(--berita-border);
}

/* ---- Cards ---- */
.berita-card-wrap {
  border-radius: 12px;
  overflow: hidden;
}

.berita-card {
  border-radius: 12px !important;
  box-shadow: var(--berita-shadow) !important;
  border: 1px solid var(--berita-border);
  overflow: hidden;
  transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
}

.berita-card:hover {
  box-shadow: var(--berita-shadow-hover) !important;
  transform: translateY(-4px);
  border-color: var(--berita-primary);
}

.berita-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--berita-primary), var(--berita-accent));
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
  border-radius: 12px 0 0 12px;
}

.berita-card:hover::before {
  opacity: 1;
}

.berita-card-image-wrap {
  overflow: hidden;
  border-radius: 12px 12px 0 0;
}

.berita-card-image {
  width: 100%;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
  transition: transform 0.45s ease;
}

.berita-card:hover .berita-card-image {
  transform: scale(1.04);
}

.berita-card-body {
  background: var(--berita-surface);
}

.berita-card-title {
  font-weight: 700;
  color: var(--berita-text);
  line-height: 1.4;
  font-size: 0.9375rem;
}

.berita-card-meta {
  color: var(--berita-text-muted);
  font-size: 0.75rem;
}

.berita-card-meta-icon {
  color: var(--berita-primary) !important;
}

.berita-card-excerpt {
  color: var(--berita-text-muted);
  min-height: 47px;
  height: 47px;
  max-height: 47px;
  opacity: 0.9;
  font-size: 0.8125rem;
  line-height: 1.4;
}

.berita-card-divider {
  border-color: var(--berita-border) !important;
  opacity: 0.8;
}

.berita-card-date {
  color: var(--berita-text-muted);
  opacity: 0.9;
  font-size: 0.75rem;
}

/* ---- Pagination ---- */
.berita-pagination {
  width: 100%;
}

.berita-pagination-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--berita-surface);
  border: 1px solid var(--berita-border);
  border-radius: 12px;
  box-shadow: var(--berita-shadow);
}

.berita-pagination-info {
  color: var(--berita-text-muted);
  font-size: 0.875rem;
}

/* Pagination buttons - rapi & konsisten */
.berita-pagination-control.v-pagination {
  flex-wrap: wrap;
  justify-content: center;
}

.berita-pagination-control.v-pagination .v-pagination__item,
.berita-pagination-control.v-pagination .v-pagination__navigation {
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  margin: 0 3px !important;
  font-weight: 600;
  font-size: 0.875rem;
  box-shadow: none;
  border: 1px solid var(--berita-border);
}

.berita-pagination-control.v-pagination .v-pagination__item--is-active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.berita-pagination-control.v-pagination .v-pagination__more {
  margin: 0 2px;
  min-width: 28px;
}

@media (max-width: 600px) {
  .berita-pagination-inner {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  .berita-pagination-control.v-pagination .v-pagination__item,
  .berita-pagination-control.v-pagination .v-pagination__navigation {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
  }
}

/* ---- Sidebar ---- */
.berita-sidebar-card {
  border-radius: 12px !important;
  background: var(--berita-surface) !important;
  border: 1px solid var(--berita-border);
  box-shadow: var(--berita-shadow);
}

.berita-sidebar-content {
  padding: 1rem 1.25rem !important;
}

.berita-sidebar-title {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
}

.berita-sidebar-divider {
  border-color: var(--berita-border) !important;
}

.berita-category-item {
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease;
  min-height: 44px;
}

.berita-category-item:hover {
  background: var(--berita-primary-soft) !important;
}

.berita-category-item--active {
  background: var(--berita-primary-soft) !important;
  font-weight: 600;
}

.berita-category-label {
  font-size: 0.875rem !important;
}
</style>
